/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { modelKeysDeleteKey } from "../funcs/modelKeysDeleteKey.js";
import { modelKeysListKeys } from "../funcs/modelKeysListKeys.js";
import { modelKeysSetKeyEnabled } from "../funcs/modelKeysSetKeyEnabled.js";
import { modelKeysUpsertKey } from "../funcs/modelKeysUpsertKey.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListKeysResponseBody } from "../models/components/listkeysresponsebody.js";
import { ModelProviderKey } from "../models/components/modelproviderkey.js";
import {
  DeleteModelProviderKeyRequest,
  DeleteModelProviderKeySecurity,
} from "../models/operations/deletemodelproviderkey.js";
import {
  ListModelProviderKeysRequest,
  ListModelProviderKeysSecurity,
} from "../models/operations/listmodelproviderkeys.js";
import {
  SetModelProviderKeyEnabledRequest,
  SetModelProviderKeyEnabledSecurity,
} from "../models/operations/setmodelproviderkeyenabled.js";
import {
  UpsertModelProviderKeyRequest,
  UpsertModelProviderKeySecurity,
} from "../models/operations/upsertmodelproviderkey.js";
import { unwrapAsync } from "../types/fp.js";

export class ModelKeys extends ClientSDK {
  /**
   * deleteKey modelKeys
   *
   * @remarks
   * Delete a model provider key. Completions on the affected slot fall back to the project default key or the platform key.
   */
  async deleteKey(
    request: DeleteModelProviderKeyRequest,
    security?: DeleteModelProviderKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(modelKeysDeleteKey(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listKeys modelKeys
   *
   * @remarks
   * List the model provider keys configured for a project. Key material is never returned.
   */
  async listKeys(
    request?: ListModelProviderKeysRequest | undefined,
    security?: ListModelProviderKeysSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListKeysResponseBody> {
    return unwrapAsync(modelKeysListKeys(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setKeyEnabled modelKeys
   *
   * @remarks
   * Enable or disable a model provider key without replacing its key material.
   */
  async setKeyEnabled(
    request: SetModelProviderKeyEnabledRequest,
    security?: SetModelProviderKeyEnabledSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ModelProviderKey> {
    return unwrapAsync(modelKeysSetKeyEnabled(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertKey modelKeys
   *
   * @remarks
   * Create or replace the model provider key for a slot. The key is validated with the provider, then stored encrypted.
   */
  async upsertKey(
    request: UpsertModelProviderKeyRequest,
    security?: UpsertModelProviderKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<ModelProviderKey> {
    return unwrapAsync(modelKeysUpsertKey(
      this,
      request,
      security,
      options,
    ));
  }
}
